module.exports = __webpack_public_path__ + "img/icon-account-deactivate@3x.5dd96e58.png";